<section class="content tab-section d-flex">
    <div class="content-block flex-grow-1">


        <div class="tab-content flex-grow-1 d-flex flex-column mt-3">
            <h4>Important Update: Exciting Changes Await!</h4>

            <p class="mt-4"> Dear Univate Users,</p>
            <p> We're thrilled to announce that Univate Learning has undergone a stunning makeover! 🚀✨ Experience the
                new and improved Univate Learning portal with its enhanced features and a fresh look designed to elevate
                your learning journey.</p>

            <p class="text-bold">
                🕰 Temporary Access to Univate Recruitment:
            </p>
            <p> While Univate Recruitment continues to thrive on the existing portal, we're working diligently to bring
                you an updated experience in the coming months.</p>
            <p> In the meantime, for Univate Recruitment, please access the Old Portal using the button below:</p>
            <div class="r-btn"> 
                <button mat-raised-button color="primary"  (click)="onUnivateRec()"
                class="auth-form-btn" type="submit">Go to Univate Recruitment</button>

            </div>
            <p> We appreciate your patience and understanding as we make these improvements. Stay tuned for the future
                updates to Univate Recruitment that will align with the standard of excellence you expect from us.</p>

            <p> Thank you for being part of the Univate community!</p>
            <p> Best regards,<br> The Univate Team</p>
            










        </div>
    </div>
</section>